/**
 * desktop-content-header.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Typography,
} from '@mui/material';
// import HelpDialog from 'components/help-dialog';
// import Icon from 'components/icon';
// import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'space-between',
    minHeight: theme.spacing(6),
    padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
  },
  title: {
    flex: 1,
    lineHeight: 1.2,
  },
  actions: {
    '& > *:not(.MuiIconButton-root)': {
      marginLeft: theme.spacing(2),
    }
  },
}));

export default function DesktopContentHeader(props) {
  const {
    title,
    actions,
    className,
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <>
      <div className={`flex-hc ${className || ''} ${classes.container} desktop-drawer-header-container`} {...rest}>
        <Typography variant="h5" className={`flex-hc ${classes.title} title`} data-testid="desktop-drawer-content-title">
          {title}
        </Typography>
        <div className={`flex-hc ${classes.actions}`}>
          {actions}
        </div>
      </div>
    </>
  );
}

